export class GetLoanProducts {
	static readonly type = '[LoanProduct] GetLoanProducts';
	constructor(public borrowerId: number) {}
}

export class GetLoanProduct {
	static readonly type = '[LoanProduct] GetLoanProduct';
	constructor(public borrowerId: number, public loanProductId: number) {}
}

export class ClearLoanProductsStore {
	static readonly type = '[LoanProduct] ClearLoanProducts';
	constructor(public borrowerId: number) {}
}

export class GetLoanProductSortSettings {
  static readonly type = '[LoanProduct] GetLoanProductSortSettings';
  constructor(public borrowerId: number) {}
}
